module.exports = __webpack_public_path__ + "svgs/no-goods.dd416f57.svg";